var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedforeldre(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5203_7954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 12.75C19.0711 12.75 20.75 14.4289 20.75 16.5V31.5C20.75 33.5711 19.0711 35.25 17 35.25C14.9289 35.25 13.25 33.5711 13.25 31.5V16.5C13.25 14.4289 14.9289 12.75 17 12.75Z",
    stroke: "#84ACAE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 12.75C34.0711 12.75 35.75 14.4289 35.75 16.5V31.5C35.75 33.5711 34.0711 35.25 32 35.25C29.9289 35.25 28.25 33.5711 28.25 31.5V16.5C28.25 14.4289 29.9289 12.75 32 12.75Z",
    stroke: "#84ACAE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0929 14.1268L29.0929 14.1268L29.0962 14.1232C29.2804 13.9195 29.4498 13.7438 29.6246 13.6007C32.0646 11.6112 35.7411 13.3523 35.75 16.5012C35.7497 17.4591 35.3837 18.4157 34.6497 19.1497L26.9706 26.8288L26.9697 26.8297L24.5 29.2911L22.0303 26.8297L22.0294 26.8288L14.3503 19.1497C13.6163 18.4156 13.2503 17.459 13.25 16.501C13.2591 13.3436 16.9348 11.6099 19.3759 13.6012L19.3818 13.6059L19.3878 13.6106C19.5706 13.7537 19.7315 13.914 19.8795 14.0949L19.8929 14.1112L19.9071 14.1268L20.0156 14.2451C21.2147 15.5688 22.8597 16.23 24.5 16.23C26.1403 16.23 27.7853 15.5688 28.9844 14.2451C28.9849 14.2445 28.9855 14.2439 28.986 14.2433L29.0929 14.1268Z",
    stroke: "#84ACAE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5203_7954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8.5 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedforeldre);
export default __webpack_public_path__ + "static/media/medforeldre.4144e90cf4c7ac7b87e48cf95c270eb7.svg";
export { ForwardRef as ReactComponent };